import cx from 'classnames';
import _ from 'lodash';
import { useFormControlContext } from './useFormControl';
import { ReactNode, DetailedHTMLProps, InputHTMLAttributes, HTMLAttributes } from 'react';

interface IFormControlSwitchProps
  extends Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'size'> {
  disabledLabel?: string;
  enabledLabel?: string;
  inlineLabel?: ReactNode;
  inlineSubLabel?: ReactNode;
  reverse?: boolean;
  wrapperProps?: HTMLAttributes<HTMLLabelElement>;
  size?: 'small' | 'medium';
  variant?: 'raiderio';
}

export const FormControlSwitch = (props: IFormControlSwitchProps) => {
  const {
    className,
    disabledLabel,
    enabledLabel,
    disabled,
    inlineLabel,
    inlineSubLabel,
    reverse,
    wrapperProps,
    size,
    variant,
    ...restProps
  } = props;

  const { readOnly } = useFormControlContext() || {};

  return (
    <label
      {..._.omit(wrapperProps, 'className')}
      className={cx('slds-checkbox--toggle slds-grid--vertical-align-center rio-form-switch', wrapperProps?.className, {
        'rio-form-switch--raiderio': variant === 'raiderio',
        'slds-grid--reverse': reverse,
        'slds-checkbox--toggle--small': size === 'small'
      })}
    >
      <input disabled={disabled || readOnly} className={className} type="checkbox" {...restProps} />

      <span id="toggle-desc" className="slds-checkbox--faux_container slds-text-align--center" aria-live="assertive">
        <span className="slds-checkbox--faux" />
        {enabledLabel && <span className="slds-checkbox--on text-white">{enabledLabel}</span>}
        {disabledLabel && <span className="slds-checkbox--off text-white">{disabledLabel}</span>}
      </span>

      <div
        className={cx(
          'slds-form-element__label slds-m-bottom--none',
          reverse ? 'slds-m-right--small' : 'slds-m-left--small'
        )}
      >
        {inlineLabel && <div>{inlineLabel}</div>}
        {inlineSubLabel && <div className="text-muted">{inlineSubLabel}</div>}
      </div>
    </label>
  );
};
